module.exports = __webpack_public_path__ + "static/media/ts_help2.6aabffb5.png";